/**
 * Base adapter class that defines the interface for transforming partner-specific orders
 * into a unified format. All partner-specific adapters should extend this class.
 */
export class BaseOrderAdapter {
    /**
     * Transform partner-specific order to unified format
     * @param {Object} orderData Raw order data from partner
     * @returns {Object} Unified order object
     */
    transformOrder(orderData) {
        throw new Error('transformOrder method must be implemented');
    }

    /**
     * Get the unified status from partner-specific status
     * @param {string} status Partner-specific status
     * @returns {string} Unified status
     */
    getUnifiedStatus(status) {
        throw new Error('getUnifiedStatus method must be implemented');
    }

    /**
     * Transform customer details
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedCustomer} Unified customer object
     */
    transformCustomer(data) {
        throw new Error('transformCustomer method must be implemented');
    }

    /**
     * Transform order items
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedOrderItem[]} Array of unified item objects
     */
    transformItems(data) {
        throw new Error('transformItems method must be implemented');
    }

    /**
     * Transform bill transaction logs
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedBillTxnLog} Unified bill transaction logs object
     */
    transformBillTxnLogs(data) {
        throw new Error('transformBillTxnLogs method must be implemented');
    }

    /**
     * Transform delivery details
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedDelivery} Unified delivery object
     */
    transformDelivery(data) {
        throw new Error('transformDelivery method must be implemented');
    }

    /**
     * Transform restaurant details
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedRestaurant} Unified restaurant object
     */
    transformRestaurant(data) {
        throw new Error('transformRestaurant method must be implemented');
    }

    /**
     * Transform order metadata
     * @param {Object} data Partner-specific order data
     * @returns {UnifiedOrderMeta} Unified order metadata object
     */
    transformOrderMeta(data) {
        throw new Error('transformOrderMeta method must be implemented');
    }

    /**
     * Get the partner identifier
     * @returns {string} Partner identifier
     */
    getPartnerId() {
        throw new Error('getPartnerId method must be implemented');
    }

    /**
     * Get the partner name
     * @returns {string} Partner name
     */
    getPartnerName() {
        throw new Error('getPartnerName method must be implemented');
    }
}